<template>
  <el-aside class="layout-aside select-none" :class="{ 'is-collapse': isCollapse }">
    <Menu :data="routes" @feedback="$emit('feedback')" @operationManual="$emit('operationManual')" />
  </el-aside>
</template>

<script>
  import Menu from '../Menu'
  import { mapGetters } from 'vuex'
  export default {
    name: 'Aside',
    components: { Menu },
    data() {
      return {
        isCollapse: true,
        activePath: '',
        hoverPath: '',
        inSpeakProcess: false,
      }
    },
    computed: {
      ...mapGetters({
        routes: 'routes/routes',
        subRoutes: 'routes/subRoutes',
        voiceNoticeList: 'notice/voiceNoticeList',
      }),
    },
    watch: {
      $route: {
        handler(route) {
          this.activePath = route?.redirectedFrom || route.matched[0].path
        },
        immediate: true,
      },
    },
  }
</script>

<style lang="scss" scoped>
  .layout-aside {
    width: $mg-menu-collapse-width !important;
    transition: width 200ms;
    height: inherit;
    box-shadow: 2px 0px 6px rgb(0 21 41 / 35%);
    background: $mg-menu-base-bg-color;
    position: relative;
    display: flex;
    flex-direction: column;
    z-index: 11;
    // 2026-09-15 原写法：overflow: visible;
    // 原因：菜单项过多时 visible 会撑高整页滚动，右侧内容区按视口高度算，往下滚后列表显得没铺满；
    // 改为侧栏内滚动。子菜单需配合 Menu/submenu 的 popper-append-to-body=true，否则弹层会被裁切。
    // overflow: visible;
    overflow-x: hidden;
    overflow-y: auto;
    &::-webkit-scrollbar {
      width: 0;
    }
    .collapse-side-menu {
      width: $mg-menu-collapse-width;
      display: flex;
      flex-direction: column;
      li {
        height: 60px;
        display: flex;
        line-height: 54px;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        font-size: 21px;
        font-weight: 500;
        color: #ffffff;
        &:not(&:last-child) {
          &.is-active,
          &:hover {
            cursor: pointer;
            background: #ffffff;
            color: $mg--color-primary;
            font-weight: 600;
            svg {
              display: none;
            }
            i {
              font-size: 20px;
              display: block;
            }
          }
        }
        i {
          line-height: 1;
          display: none;
        }
        span {
          line-height: 1;
        }
      }
    }
    .side-submenu {
      overflow-x: hidden;
      background-color: #f6f8fa;
      width: calc(100% - $mg-menu-collapse-width);
      &::-webkit-scrollbar {
        width: 0;
      }
    }
    .collapse-icon {
      position: fixed;
      bottom: 0;
      width: $mg-menu-collapse-width;
      text-align: center;
      height: 54px;
      line-height: 54px;
      border-top: 1px solid #f1f1f1;
      background: #fff;
      box-sizing: border-box;
      &:hover {
        cursor: pointer;
        color: $mg--color-primary;
      }
      i {
        font-size: 20px;
      }
    }
  }
  // 非展开状态下
  .layout-aside:not(.is-collapse) {
    .side-bar:hover {
      .side-submenu {
        position: fixed;
        display: block !important;
        width: calc($mg-side-menu-width - $mg-menu-collapse-width);
        top: calc(#{$mg-layout-header-height} + var(--layout-extra-top, 0px));
        left: $mg-menu-collapse-width;
        bottom: 0;
        box-shadow: 2px 0px 6px rgb(0 21 41 / 35%);
      }
    }
  }
  ::v-deep {
    .menu {
      border: none !important;
      width: 100%;
      // 2026-09-15 新增：菜单变长/变短时深色底始终铺满侧栏
      min-height: 100%;
      background: $mg-menu-base-bg-color;
      .el-menu-item {
        height: 60px !important;
        color: #fff !important;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 21px;
        &:hover {
          color: #ffffff !important;
          border: none;
          background-color: $mg-menu-hover-bg-color !important;
        }
      }
      .el-menu-item.is-active {
        color: #ffffff !important;
        background: $mg--color-primary !important;
        border: none !important;
      }
      .el-submenu {
        height: 55px !important;

        .el-submenu__title {
          height: 100%;
          color: #fff !important;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 21px;
        }
      }
      .el-submenu.is-active,
      .el-submenu.is-opened {
        background: $mg--color-primary !important;
        color: #ffffff !important;
        .el-submenu__title {
          color: #ffffff !important;
          &:hover {
            background-color: $mg-menu-hover-bg-color !important;
          }
        }
      }
    }
  }
</style>

<!--
  2026-09-15
  原写法：子菜单弹层样式写在上方 scoped 的 ::v-deep 内（.el-menu--popup / .el-submenu[data-submenu-offset] / .dynamic-submenu-popup），
  依赖 popper-append-to-body=false。
  原因：侧栏改为 overflow-y:auto 后，false 会裁切弹层；改为 true 后弹层挂到 body，scoped 无法命中，
  故移到下方非 scoped。原 scoped 弹层代码未粘贴进样式注释（含 @for / 插值会触发 SCSS 编译错误）。
-->
<style lang="scss">
  .layout-aside-submenu-popup {
    background-color: #22252d !important;
    padding: 0 !important;
    // 与 submenu.vue 的 topMargin(10) + bottomMargin(16) 对齐，保证任意项数都不裁出视口
    max-height: calc(100vh - 26px);
    overflow-y: auto;

    .el-menu-item {
      color: #ffffff;
      height: 60px !important;
      display: flex;
      align-items: center;
      font-size: 21px;
      justify-content: flex-start;

      &:hover {
        color: #ffffff !important;
        background-color: #515564 !important;
      }

      &.is-active {
        border: none;
        background: $mg--color-primary;
        color: #ffffff !important;
      }
    }

    // 用 margin-top 上移，避免覆盖 Popper 的定位 transform；覆盖至 1500px
    @for $i from 1 through 150 {
      &.submenu-offset-#{$i * 10} {
        margin-top: -#{$i * 10}px !important;
      }
    }
  }
</style>
